import React from 'react';

const LimitIndicator = ({
  limitReached = false,
  fallbackActive = false,
  message,
  contactEmail
}) => {
  if (!limitReached && !fallbackActive) return null;

  // Combined state: both limit reached and fallback active
  if (limitReached && fallbackActive) {
    return (
      <div className="limit-indicator limit-indicator-reached" role="alert">
        <span className="limit-indicator-text">{message || 'Limit Reached'}</span>
        <span className="limit-indicator-detail">
          Your usage has been switched to a basic service tier.
        </span>
        {contactEmail && (
          <span className="limit-indicator-contact-wrap">
            Contact support at{' '}
            <a
              className="limit-indicator-contact"
              href={`mailto:${contactEmail}`}
              aria-label={`Email support at ${contactEmail}`}
            >
              {contactEmail}
            </a>{' '}
            to increase your limit.
          </span>
        )}
      </div>
    );
  }

  if (fallbackActive) {
    return (
      <div className="limit-indicator limit-indicator-fallback" role="status">
        <span className="limit-indicator-text">
          Fallback mode active. Your usage has been switched to a basic service tier.
        </span>
        {contactEmail && (
          <span className="limit-indicator-contact-wrap">
            Contact support at{' '}
            <a
              className="limit-indicator-contact"
              href={`mailto:${contactEmail}`}
              aria-label={`Email support at ${contactEmail}`}
            >
              {contactEmail}
            </a>
          </span>
        )}
      </div>
    );
  }

  return (
    <div className="limit-indicator limit-indicator-reached" role="alert">
      <span className="limit-indicator-text">{message || 'Limit Reached'}</span>
      {contactEmail && (
        <span className="limit-indicator-contact-wrap">
          Contact support at{' '}
          <a
            className="limit-indicator-contact"
            href={`mailto:${contactEmail}`}
            aria-label={`Email support at ${contactEmail}`}
          >
            {contactEmail}
          </a>{' '}
          to increase your limit.
        </span>
      )}
    </div>
  );
};

export default LimitIndicator;
